import userSession from '../../config/userSession.json';
import types from './types';
import MS_PER_MINUTE from './constants';

const sessionReducer = (state = { status: 'INITIAL', expireAt: null, config: { ...userSession } }, action) => {
  switch (action.type) {
    case types.SET_SESSION_STATUS:
      const now = Date.now();
      return {
        ...state,
        status: action.payload,
        expireAt: action.payload === 'ACTIVE'
          ? now + state.config.timeout * MS_PER_MINUTE
          : null,
        warnAt: action.payload === 'ACTIVE'
          ? now + (state.config.timeout - state.config.warnBefore) * MS_PER_MINUTE
          : null
      };
    case types.SET_SESSION_CONFIG:
      return {
        ...state,
        config: action.payload
      };
    case types.SET_SOCKET:
      return {
        ...state,
        socket: action.payload
      };
    default:
      return state;
  }
};

export default sessionReducer;
